import { z } from 'zod';
import { UUIDSchema } from './common';
import { NotificationSettingsSchema } from './notification_settings';
export const UserRoleSchema = z.enum(['appraiser', 'customer']);
export const UserLocaleSchema = z.enum(['de-DE', 'en-US']);
export const BaseUserSchema = z.object({
    id: z.number(),
    uuid: UUIDSchema,
    profile_image_url: z.string().optional(),
    profile_thumbnail_image_url: z.string().optional(),
    email: z.string(),
    role: UserRoleSchema,
    organization_name: z.string(),
    is_platform_user: z.boolean().optional(),
    is_active: z.boolean().optional(),
    salutation: z.string().optional(),
    title: z.string().optional(),
    job_title: z.string().optional(),
    phone_number: z.string().optional(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    locale: UserLocaleSchema.optional(),
    pinned_threads: z.array(UUIDSchema),
});
export const CustomerUserSchema = BaseUserSchema.extend({
    role: z.literal('customer'),
    notification_settings: NotificationSettingsSchema,
    customer_uuid: UUIDSchema,
    team_uuid: UUIDSchema.optional(),
    company_name: z.string().optional(),
});
export const AppraiserUserSchema = BaseUserSchema.extend({
    role: z.literal('appraiser'),
    certification: z.string().optional(),
    notification_settings: NotificationSettingsSchema,
});
export const RootUserSchema = z.discriminatedUnion('role', [
    CustomerUserSchema,
    AppraiserUserSchema,
]);
export const isAppraiserUser = (user) => user?.role === 'appraiser';
const AppraiserLegacyAppraiserUserSchema = AppraiserUserSchema.omit({
    locale: true,
});
const AppraiserLegacyCustomerUserSchema = CustomerUserSchema.omit({
    locale: true,
    company_name: true,
});
export const AppraiserLegacyUserSchema = z.discriminatedUnion('role', [
    AppraiserLegacyAppraiserUserSchema,
    AppraiserLegacyCustomerUserSchema,
]);
const ClientPortalLegacyAppraiserUserSchema = AppraiserUserSchema.omit({
    certification: true,
    notification_settings: true,
});
const ClientPortalLegacyCustomerUserSchema = CustomerUserSchema.omit({
    company_name: true,
});
export const ClientPortalLegacyUserSchema = z.discriminatedUnion('role', [
    ClientPortalLegacyAppraiserUserSchema,
    ClientPortalLegacyCustomerUserSchema,
]);
export const AppraisingEntitySchema = z.object({
    uuid: UUIDSchema,
    name: z.string(),
    order_mailbox: z.string(),
});
export const AppraisingEntityListSchema = z.array(AppraisingEntitySchema);
export const AssignedAppraiserSchema = z.object({
    id: z.number(),
    organization_name: z.string().optional(),
    salutation: z.string().optional(),
    email: z.string(),
    phone_number: z.string().optional(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    certification: z.string().optional(),
    profile_image_url: z.string().optional(),
});
